import React, { Component }  from 'react'
import decodeHtml from '../functions/decodeHtml.jsx';
import SubMenuItem from './SubMenuItem.jsx'

class MenuItem extends Component {
    constructor(props) {
        super(props);

        this.MenuItemRef = React.createRef()
    }


    componentDidMount() {
        const {ID, getItemWidth} = this.props
        if(getItemWidth) {
            const widthWithGap = this.MenuItemRef.current.offsetWidth + 30
            getItemWidth(widthWithGap, ID)
        }
    }

    getFilterChildrens(filterKey, isActive, baseUrl) {
        const { attributes, programOverviewSubmenus } = this.props
        const filterItems = programOverviewSubmenus[filterKey]
        if(!attributes) {
            return ''
        }
        const attrData = attributes[filterKey]

        return filterItems.map((filterItem, index) => {
            const search = '?' + filterKey + '=' + filterItem
            const title = attrData[filterItem].name

            return {
                ID: 'filter-' + index, 
                url: isActive ? search : baseUrl + search,
                title: title,
                isFilter: isActive
            }
        })
    }

    render() {
        const {ID, index, title, menuItem, onMouseEnter, onMouseLeave, onToggleNavigation = () => {}, isLast=false, translation } = this.props
        const isActive = menuItem.is_active
        const activeClass= isActive ? ' sub-menu-item-active' : ''
        const isLastClass = isLast ? ' last' : ''
        let menuItemChildren = []
        let itemChildrenList = []
        const menuClass = menuItem.classes ? menuItem.classes.join(' ') : ''

        if(menuItem.classes && _.contains(menuItem.classes, 'borlabs-cookie-open-dialog-preferences')) {
            return <li ref={this.MenuItemRef} key={index} id={"menu-item-" + ID } className={"menu-item cursor-pointer " + menuItem.menu_attribute + activeClass + isLastClass} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
                <p className="text-medium-navigation">
                    <span className={"menu-item-link " + menuClass} data-borlabs-cookie-title={title}></span>
                </p>
            </li>
        }
        
        if(menuItem.classes && _.contains(menuItem.classes, 'borlabs-cookie-preference')) {
            return <li ref={this.MenuItemRef} key={index} id={"menu-item-" + ID } className={"menu-item cursor-pointer " + menuItem.menu_attribute + activeClass + isLastClass} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
                <p className="text-medium-navigation"> 
                    <span className={"menu-item-link " + menuClass}>{title}</span>
                </p>
            </li>
        }
        
        if(_.has(menuItem, 'children') || menuItem.is_overview) {
            if(menuItem.children) {
                menuItemChildren = menuItem.children
            }
           
            if(menuItem.is_overview) {
                const baseUrl = menuItem.url
                const filterGenre = this.getFilterChildrens('genres', isActive, baseUrl)
                const filterTech = this.getFilterChildrens('technical', isActive, baseUrl)
                menuItemChildren = menuItemChildren.concat(filterGenre, filterTech)
            }

            itemChildrenList = menuItemChildren.map((childItem, index) => {
                if(!childItem) {
                    return ''
                }
                const { ID, url, title, isFilter, target, menu_attribute } = childItem

                const decodeTitle = decodeHtml(title)

                return <SubMenuItem 
                    key={index}
                    index={index}
                    target={target}
                    menuClass={menuClass}
                    menu_attribute={menu_attribute}
                    id={ID}
                    translation={translation}
                    activeClass={activeClass}
                    url={url}
                    title={decodeTitle}
                    isFilter={isFilter}
                    onToggleNavigation={onToggleNavigation}
                />
            })
        }

        if(menuItemChildren.length > 0) {
            return (
                <li ref={this.MenuItemRef} key={index} id={"menu-item-" + ID } className={"menu-item cursor-pointer " + menuItem.menu_attribute + activeClass + isLastClass} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
                    {menuItem.target ? (
                        <a className="text-medium-navigation" href={menuItem.url} onClick={() => onToggleNavigation()} target={menuItem.target}><span className={"menu-item-link " + menuClass}>{title}</span></a>
                    ) : (
                        <a className="text-medium-navigation" href={menuItem.url} onClick={() => onToggleNavigation()}><span className={"menu-item-link " + menuClass}>{title}</span></a>
                    )}
                    <ul className="sub-menu">
                        {itemChildrenList}      
                    </ul>
                </li>
            )
        } else {
            return (
                <li ref={this.MenuItemRef} key={index} id={"menu-item-" + ID } className={"menu-item cursor-pointer " + menuItem.menu_attribute + activeClass + isLastClass}>
                    {menuItem.target ? (
                        <a className="text-medium-navigation" href={menuItem.url} onClick={() => onToggleNavigation()} target={menuItem.target}><span className={"menu-item-link " + menuClass}>{title}</span></a>
                    ) : (
                        <a className="text-medium-navigation" href={menuItem.url} onClick={() => onToggleNavigation()}><span className={"menu-item-link " + menuClass}>{title}</span></a>
                    )}
                </li>
            )
        }
    }
}

export default MenuItem